import { AxiosError } from "axios";
import { HttpError, HttpErrorCode } from "./http-error";
import { ApiError, ApiErrorCode, type ApiErrorDetails } from "./api-error";
import { useIntl } from "../i18n";
import { HttpErrorFactory } from "./http-error-factory";


export class ApiErrorFactory {
    public static fromAxiosError(exception: any): ApiError {
        if (exception instanceof ApiError) {
            return exception;
        }

        let error: ApiError;
        let apiErrorDetails: Partial<ApiErrorDetails> = {};
        let message = "";
        let url = "";
        let method = "";
        let status = 0;
        let innerError = exception;
        let errorCode = ApiErrorCode.OtherError;

        if (exception instanceof AxiosError) {

         

            if (exception.response?.data.Status && exception.response?.data.StatusCategory) {
                innerError = HttpErrorFactory.fromHttpError(exception, "API", false) as HttpError;
                errorCode = ApiErrorCode.ResponseDataExpressedError
                apiErrorDetails.statusCode = exception.response.data.Status;
                apiErrorDetails.statusCategory = exception.response.data.StatusCategory;
                apiErrorDetails.apiStack = {
                    type: exception.response.data.__ExceptionInfo?.Type,
                    message: exception.response.data.__ExceptionInfo?.Message,
                    stack: exception.response.data.__ExceptionInfo?.StackTrace
                };

                apiErrorDetails.correlationId = exception.response.data.CorrelationId;

                switch (apiErrorDetails.statusCode) {
                    case "ConcurrencyError":
                        message = useIntl().i18n.t("shared.errors.errorTypes.apiError.concurrencyError");
                        break;
                    case "Unauthorized":
                        message = useIntl().i18n.t("shared.errors.errorTypes.apiError.unauthorizedError");
                        break;
                    default:
                        message = useIntl().i18n.t("shared.errors.errorTypes.apiError.defaultError");;
                        break;
                }

                if (exception.config) {
                    url = exception.config.url ?? "";
                    method = exception.config.method ?? "";
                }

            }
            else {
                innerError = HttpErrorFactory.fromHttpError(exception, "API", true) as HttpError;
                switch (innerError.statusCode) {
                    case 401:
                        apiErrorDetails.statusCode = "Unauthorized";
                        break;
                    case 403:
                        apiErrorDetails.statusCode = "Forbidden";
                        break;
                    default:
                        apiErrorDetails.statusCode = "Unknown";
                        break;
                }

                apiErrorDetails.statusCategory = "Unknown";
                apiErrorDetails.correlationId = exception.response?.headers["x-request-id"];
                message = useIntl().i18n.t("shared.errors.errorTypes.apiError.defaultError");;
            }


        }
        else {
        }

        error = new ApiError("API", errorCode, message, url, method, status, apiErrorDetails as ApiErrorDetails, exception.stack, innerError);
        return error;
    }
}
